const INCIDENT_STATUS_IDS = {
  NEW: 1,
  PENDING_REVIEW: 2,
  REVISION: 3,
  IN_PROGRESS: 4,
  RESOLVED: 5,
} as const

const EDITABLE_INCIDENT_STATUS_IDS = [
  INCIDENT_STATUS_IDS.NEW,
  INCIDENT_STATUS_IDS.REVISION,
]

const INCIDENT_STATUS_ACTIONS: Record<
  number,
  Array<{
    statusId: number
    label: string
    color: string
    commentRequired?: boolean
  }>
> = {
  [INCIDENT_STATUS_IDS.NEW]: [
    {
      statusId: INCIDENT_STATUS_IDS.PENDING_REVIEW,
      label: 'Передати на розгляд',
      color: 'primary',
    },
  ],
  [INCIDENT_STATUS_IDS.PENDING_REVIEW]: [
    {
      statusId: INCIDENT_STATUS_IDS.IN_PROGRESS,
      label: 'В роботу',
      color: 'primary',
    },
    {
      statusId: INCIDENT_STATUS_IDS.REVISION,
      label: 'Повернути на доопрацювання',
      color: 'warning',
      commentRequired: true,
    },
  ],
  [INCIDENT_STATUS_IDS.REVISION]: [
    {
      statusId: INCIDENT_STATUS_IDS.PENDING_REVIEW,
      label: 'Повернути на розгляд',
      color: 'primary',
    },
  ],
  [INCIDENT_STATUS_IDS.IN_PROGRESS]: [
    {
      statusId: INCIDENT_STATUS_IDS.RESOLVED,
      label: 'Врегулювати інцидент',
      color: 'success',
    },
  ],
  [INCIDENT_STATUS_IDS.RESOLVED]: [],
}

const INCIDENT_STATUS_COLORS: Record<number, string> = {
  [INCIDENT_STATUS_IDS.NEW]: '#1565a9',
  [INCIDENT_STATUS_IDS.PENDING_REVIEW]: '#5e35b1',
  [INCIDENT_STATUS_IDS.REVISION]: '#b42318',
  [INCIDENT_STATUS_IDS.IN_PROGRESS]: '#b66f00',
  [INCIDENT_STATUS_IDS.RESOLVED]: '#187a4d',
}

const INCIDENT_STATUS_CHIP_STYLES: Record<number, Record<string, string>> = {
  [INCIDENT_STATUS_IDS.NEW]: {
    backgroundColor: '#eaf4ff',
    borderColor: '#9bcaf5',
    color: INCIDENT_STATUS_COLORS[INCIDENT_STATUS_IDS.NEW],
  },
  [INCIDENT_STATUS_IDS.PENDING_REVIEW]: {
    backgroundColor: '#f1edff',
    borderColor: '#c7b8ff',
    color: INCIDENT_STATUS_COLORS[INCIDENT_STATUS_IDS.PENDING_REVIEW],
  },
  [INCIDENT_STATUS_IDS.REVISION]: {
    backgroundColor: '#fff1f1',
    borderColor: '#f1aaaa',
    color: INCIDENT_STATUS_COLORS[INCIDENT_STATUS_IDS.REVISION],
  },
  [INCIDENT_STATUS_IDS.IN_PROGRESS]: {
    backgroundColor: '#fff8e8',
    borderColor: '#f4cf89',
    color: INCIDENT_STATUS_COLORS[INCIDENT_STATUS_IDS.IN_PROGRESS],
  },
  [INCIDENT_STATUS_IDS.RESOLVED]: {
    backgroundColor: '#e9f8f0',
    borderColor: '#9bdcbb',
    color: INCIDENT_STATUS_COLORS[INCIDENT_STATUS_IDS.RESOLVED],
  },
}

const INCIDENT_PRIORITY_COLORS: Record<number, string> = {
  1: 'green',
  2: 'amber-darken-2',
  3: 'deep-orange',
  4: 'red',
}

const INCIDENT_RISK_PROBABILITY_STYLES: Record<
  number,
  Record<string, string>
> = {
  1: {
    backgroundColor: '#e9f8f0',
    color: '#187a4d',
  },
  2: {
    backgroundColor: '#fff8e8',
    color: '#b66f00',
  },
  3: {
    backgroundColor: '#fff1f1',
    color: '#c9362c',
  },
}

const getIncidentStatusChipStyle = (statusId?: number | null) => {
  return statusId ? INCIDENT_STATUS_CHIP_STYLES[statusId] : undefined
}

const getIncidentPriorityColor = (priorityId?: number | null) => {
  return priorityId ? INCIDENT_PRIORITY_COLORS[priorityId] : undefined
}

const getIncidentRiskProbabilityStyle = (probabilityId?: number | null) => {
  return probabilityId
    ? INCIDENT_RISK_PROBABILITY_STYLES[probabilityId]
    : undefined
}

export {
  EDITABLE_INCIDENT_STATUS_IDS,
  getIncidentPriorityColor,
  getIncidentRiskProbabilityStyle,
  getIncidentStatusChipStyle,
  INCIDENT_STATUS_ACTIONS,
  INCIDENT_STATUS_IDS,
}
